import * as React from 'react';
import { Spinner } from 'react-bootstrap';

export default class OrdenesDeLiquidacionBorrador extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ordenes: props.ordenes,
            seleccionarTodo: false
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.ordenes !== this.props.ordenes) {
            this.setState({ ordenes: this.props.ordenes })
        }
    }

    handleChangeCheckbox = (id) => {
        this.setState((prevState) => {
            const ordenes = prevState.ordenes.map((orden) => {
                if (orden.idOrden === id) {
                return {
                    ...orden,
                    checked: !orden.checked
                };
                }
                return orden;
            });
            return { ordenes };
        });
    };

    handleSelectAllCheckbox(seleccionarTodo) {
        this.setState((prevState) => {
            const ordenes = prevState.ordenes.map((orden) => ({
                ...orden,
                checked: seleccionarTodo
            }));
            return { ordenes };
        });

        this.setState({ seleccionarTodo: seleccionarTodo });
    };


    render = () => {

        const ordenes = this.props.ordenes;
        
        return (

            this.props.isLoading ?

            <div className="d-flex justify-content-center">
                <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </div>

            :

            ordenes.length > 0 ?

            <div className="row justify-content-between align-items-center p-10">

                <div className="col-auto my-4">
                    <input
                        type="checkbox" 
                        className="big-checkbox"
                        checked={this.state.seleccionarTodo}
                        onChange={() => this.handleSelectAllCheckbox(!this.state.seleccionarTodo)}
                    />
                    <h6 className="d-inline-flex mx-2">Seleccionar todo</h6>
                </div>

                <h5 className="col-auto card-title">Ordenes</h5>

                <div className="list-group-item col-12 animated fadeIn">
                    <div className="table-responsive card">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col"><small>#</small></th>
                                    <th scope="col"><small>N° Orden</small></th>
                                    <th scope="col"><small>Tipo</small></th>
                                    <th scope="col"><small>Estado</small></th>
                                    <th scope="col"><small>Fecha</small></th>
                                    <th scope="col"><small>Importe</small></th>
                                    <th scope="col"><small>Comisión Neta</small></th>
                                    <th scope="col"><small>Comisión Total</small></th>
                                    <th scope="col"><small>Importe Total</small></th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.ordenes.map((orden, i) => {
                                    return (
                                            
                                        <tr key={i} className="hover-background-color">
                                            <td>
                                                <input 
                                                    type="checkbox" 
                                                    className="big-checkbox ml-2"
                                                    hidden={orden.importeOrden === 0}
                                                    checked={orden.checked || false}
                                                    onChange={() => this.handleChangeCheckbox(orden.idOrden)}
                                                />
                                            </td>
                                            <td><span><small>{orden.idOrden}</small></span></td>
                                            <td><span><small>{orden.tipoPublicacion}</small></span></td>
                                            <td><span><small>{orden.descripcionEstado}</small></span></td>
                                            <td><span><small>{orden.fechaOrdenMostrar}</small></span></td>
                                            <td><span><small>${orden.importeOrden}</small></span></td>
                                            <td><span><small>${orden.importeComisionNeta}</small></span></td>
                                            <td><span><small>${orden.importeComisionTotal}</small></span></td>
                                            <td><span><small>${orden.totalOrden}</small></span></td>
                                        </tr>
                                    )
                                }
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            :

            <div className="card">
                <div className="card-body">
                    <div className="row justify-content-center align-items-center p-10">
                        No hay órdenes para esta liquidación
                    </div>
                </div>
            </div>
        )
    }
}